import type { Order } from '@ztechapps/common.contract'
import type { TemplateVariables } from '@ztechapps/chat.webui'
import { buildDocumentLinkPdfUrl } from '@ztechapps/common.utils'
import { useTemplateResetPassword } from '@ztechapps/chat.webui'
import { useCreateOrderPackingSlipDocumentLink, useOrderInvoiceUrl, useOrderPdfUrl } from '@ztechapps/order.common'
import { appSettings } from '../../../config/app-settings'
import { useTemplateCreateBankTransfer } from './useTemplateCreateBankTransfer'
import { useTemplateCreatePaymentLink } from './useTemplateCreatePaymentLink'

export const useSalesOrderTemplateVariables = ({ order }: { order?: Order } = {}): TemplateVariables => {
  const invoiceUrl = useOrderInvoiceUrl({ rootUrl: appSettings.AppUrl.store, orderId: order?._id })
  const invoicePdfUrl = useOrderPdfUrl({ rootUrl: appSettings.AppUrl.store, orderId: order?._id })
  const { mint: mintPackingSlipLink } = useCreateOrderPackingSlipDocumentLink()
  const { resetPassword: resetPasswordMain } = useTemplateResetPassword()
  const { payWithCard } = useTemplateCreatePaymentLink()
  const { payWithBank } = useTemplateCreateBankTransfer()

  return {
    invoiceUrl,
    invoicePdfUrl,
    orderPackingSlipUrl: async () => {
      const { token } = await mintPackingSlipLink(order?._id)
      return buildDocumentLinkPdfUrl({ rootUrl: appSettings.AppUrl.store, token })
    },
    salesOrder: order,
    resetPassword: () => {
      return resetPasswordMain({ _id: order?.by?._id })
    },
    payWithCard,
    payWithBank,
    username: order?.by?.profile?.email,
    profileName: order?.by?.profile?.name,
  } as TemplateVariables
}
